// This list is pullled from this Slack thread
// https://vistaprint.slack.com/archives/C05L66X0UET/p1710751455887779
export const SAMPLE_QUANTITY_PRDS = new Set([
  "PRD-LMCUKFGT9",
  "PRD-CTB5UVMPP",
  "PRD-1SI3HBYB0",
  "PRD-UN2AAJKLC",
  "PRD-1NYANXIDO",
  "PRD-N9KVUFGCQ",
  "PRD-IYFGAMAUR",
  "PRD-S7USUOJFN",
  "PRD-2YDCCDI3S",
  "PRD-IRA9J9ZYN",
  "PRD-1O9IXZOA9",
  "PRD-QYSK5N7CE",
  "PRD-F0X11PZ3Q",
  "PRD-UAPTBKAXO",
  "PRD-ASIEDCOUH",
  "PRD-QFZMXW6MA",
  "PRD-WQ476CAP7",
  "PRD-Y1LEPL3MX",
  "PRD-OUVYY2FRC",
]);
